import { ArrowUpRight, Check, Infinity as InfinityIcon } from "lucide-react";
import { PACKAGES, SINGLE, UNLIMITED } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";

const USPS = ["Individuelle Erstellung nach Kundenwunsch", "Höchste Qualität & schnelle Lieferung", "Persönlicher Support", "Faire, transparente Preise"];

export const Pricing = ({ onSelect }) => (
  <section id="preise" className="relative py-28 lg:py-40 bg-[var(--bg-2)] spotlight" data-testid="pricing-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <SectionHead
        eyebrow="KI-Bildpakete"
        lines={["Flexible Pakete für", "jede Unternehmensgröße."]}
        text="Vom Einzelbild bis zur unbegrenzten Monatslösung. Alle Preise als Endpreise – Kleinunternehmer gemäß § 19 UStG, keine Umsatzsteuer ausgewiesen."
      />

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-testid="pricing-grid">
        {PACKAGES.map((p, i) => {
          const hot = !!p.badge;
          return (
            <Reveal key={p.id} delay={i * 0.1} y={30}>
              <article className={`tier relative h-full flex flex-col p-8 border ${hot ? "border-[var(--gold)] bg-[rgba(212,175,55,0.05)]" : "border-[var(--line)] bg-[var(--bg)]"}`} data-testid={`pricing-tier-${p.id}`}>
                {hot && (
                  <span className="absolute -top-3 left-8 bg-[var(--gold)] text-[#0a0a0b] font-mono text-[0.6rem] tracking-[0.25em] uppercase px-3 py-1.5" data-testid="pricing-bestseller-badge">
                    {p.badge}
                  </span>
                )}
                <p className="eyebrow">{p.name}</p>
                <p className="mt-6 font-display text-5xl lg:text-[3.5rem] font-light leading-none">{p.price}</p>
                <p className="mt-3 font-mono text-[0.7rem] tracking-[0.15em] text-[var(--muted)] uppercase">{p.images} KI-Bilder · {p.per}</p>
                <div className="hairline my-8" />
                <ul className="space-y-3 text-sm text-[var(--muted)] flex-1">
                  {["Individuelle Erstellung", "Professionelle Nachbearbeitung", "Optimiert für E-Commerce", "Persönlicher Support"].map((f) => (
                    <li key={f} className="flex items-center gap-3"><Check size={13} className="text-[var(--gold)]" /> {f}</li>
                  ))}
                </ul>
                <button onClick={() => onSelect(p.id)} className={`mt-8 w-full justify-center ${hot ? "btn-gold" : "btn-ghost"}`} data-testid={`pricing-tier-${p.id}-button`}>
                  Paket anfragen <ArrowUpRight size={15} />
                </button>
              </article>
            </Reveal>
          );
        })}
      </div>

      <div className="grid lg:grid-cols-12 gap-4 mt-4">
        <Reveal className="lg:col-span-4" delay={0.1}>
          <article className="tier h-full p-8 border border-[var(--line)] bg-[var(--bg)] flex flex-col" data-testid="pricing-tier-einzelbild">
            <p className="eyebrow">{SINGLE.name}</p>
            <div className="flex items-end gap-3 mt-6">
              <p className="font-display text-5xl font-light leading-none">{SINGLE.price}</p>
              <p className="font-mono text-[0.7rem] tracking-[0.15em] text-[var(--muted)] uppercase mb-1">{SINGLE.per}</p>
            </div>
            <p className="mt-6 text-sm text-[var(--muted)] leading-relaxed flex-1">Ideal zum Kennenlernen oder für einzelne Motive – ohne Paketbindung.</p>
            <button onClick={() => onSelect(SINGLE.id)} className="btn-ghost mt-8 w-full justify-center" data-testid="pricing-tier-einzelbild-button">
              Einzelbild anfragen <ArrowUpRight size={15} />
            </button>
          </article>
        </Reveal>

        <Reveal className="lg:col-span-8" delay={0.2}>
          <article className="tier relative h-full p-8 lg:p-10 border border-[var(--line-strong)] bg-[var(--bg)] overflow-hidden grid md:grid-cols-2 gap-8" data-testid="pricing-tier-unlimited">
            <div className="absolute -right-16 -top-16 w-72 h-72 rounded-full bg-[var(--gold)] opacity-[0.07] blur-3xl pointer-events-none" />
            <div>
              <div className="flex items-center gap-3">
                <InfinityIcon size={18} className="text-[var(--gold)]" />
                <p className="eyebrow">Unbegrenzte Anzahl Bilder pro Monat</p>
              </div>
              <div className="flex items-end gap-3 mt-6">
                <p className="font-display text-5xl lg:text-6xl font-light leading-none">{UNLIMITED.price}</p>
                <p className="font-mono text-[0.7rem] tracking-[0.15em] text-[var(--muted)] uppercase mb-1">{UNLIMITED.per}</p>
              </div>
              <button onClick={() => onSelect(UNLIMITED.id)} className="btn-gold mt-8" data-testid="pricing-tier-unlimited-button">
                Unlimited anfragen <ArrowUpRight size={15} />
              </button>
            </div>
            <ul className="space-y-4 md:pt-2">
              {UNLIMITED.features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-[var(--text)] border-b border-[var(--line)] pb-4">
                  <Check size={15} className="text-[var(--gold)] mt-1 shrink-0" /> {f}
                </li>
              ))}
            </ul>
          </article>
        </Reveal>
      </div>

      <Reveal delay={0.2}>
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 border-t border-[var(--line)] pt-8" data-testid="pricing-usps">
          {USPS.map((u, i) => (
            <div key={u} className="flex items-center gap-3 text-sm text-[var(--muted)]">
              <span className="font-mono text-[0.6rem] text-[var(--gold)]">0{i + 1}</span> {u}
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
